module.exports = __webpack_public_path__ + "static/img/差评-点击状态@4x.0a38c7c3.png";